import { useContext, useEffect, useState } from "react"
import { useNavigate, useOutletContext, useParams } from "react-router-dom"
import Modal from "../Modal"
import UserContext from "../../Context/UserContext"
import { deleteEventDoc, deleteGroupsDocWhereEvent, deleteGuestsDocWhereEvent, getEventsDoc, newEventDoc, updateEventDoc } from "../../Requests/firebaseFirestore"
import {IoDocumentText, IoMail} from 'react-icons/io5'
import {MdEdit, MdDelete, MdDownload, MdLibraryAdd, MdSearch} from 'react-icons/md'
import {write, utils} from 'xlsx'
import { saveAs } from "file-saver"
import Spinner from "../Spinner"
import AreYouSure from "../AreYouSure"
import { deleteEventMail, newEventMail } from "../../Requests/sendMail"
export default function EventsAsOrganizer(){
  const {role} = useParams('role')
  const navigate = useNavigate()
  const {user} = useContext(UserContext)
  const fakeCompany = useOutletContext()
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [events, setEvents] = useState([]) //all events from firestore
  const [eventList, setEventList] = useState([]) //the events tha are shown
  const [editing, setEditing] = useState('')
  const [search, setSearch] = useState('')
  const [sureModal, setSureModal] = useState(false)
  const [creating, setCreating] = useState(false)
  const [orderBy, setOrderBy] = useState('name')

  const emptyEvent ={
    name:'',
    date:'',
    description:'',
    country:'',
    region:'',
    city:'',
    timeZone:'',
    startTime:'',
    endTime:'',
  }
  const [newEvent, setNewEvent] = useState(emptyEvent)
  const [eventToDelete, setEventToDelete] = useState('')  
  const reloadEventList  = async (events) => {
    setLoading(true)
    if (events) {
      setEventList(events)
    } else {
      const res = await getEventsDoc()
      setEvents(res)
      setEventList(res)
    }
    setLoading(false)
  }
  useEffect(()=>{
    if (role !== 'organizer') {
      navigate(`/${user.role}`)
    }
    if (user!=='checking') {
      switch (user.role) {
        case 'organizer':
          reloadEventList()
        break;
        case 'exhibitor':
          navigate(`/${user.role}`)
        break;
        default:
          navigate(`/${user.role}`)
        break;
      }
    }
  },[role, user, navigate, fakeCompany])

  const createNewEvent = async () =>{
    setCreating(true)
    const {status, docRef, eventData} = await newEventDoc(newEvent)
    if(status === 'success'){
      await newEventMail(docRef.id, eventData)
    }
    reloadEventList()
    setShowModal(false)
    setCreating(false)
  }

  const updateEvent = async ()  => {
    setCreating(true)
    await updateEventDoc(editing, newEvent)
    reloadEventList()
    setShowModal(false)
    setCreating(false)
  }

  const handleInputChange = (e) => {
    const {name, value} = e.target
    setNewEvent({...newEvent,[name]: value})
  }


  const handleEventForm = async (e) => {
    e.preventDefault()
    if(editing===''){
      await createNewEvent()
    }else{
      await updateEvent()
    }
  }

  const handleModal = (event)=>{
    if (event) {
      const {id, ...e} = event
      setEditing(id)
      setNewEvent(e)
    } else {
      setEditing('')
      setNewEvent(emptyEvent)
    }
    setShowModal(!showModal)
  }


  const getTodaysDate = () => {
    const date = new Date()
    const today = `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`
    return today;
  }

  const handleSearchForm = (e) => {
    e.preventDefault()
    let filteredList = []
    events.forEach((event)=>{
      if(event.name.toLowerCase().includes(search.toLowerCase())){
        filteredList = [...filteredList, event]
      }
    })
    reloadEventList(filteredList)
  }

  const handleDownload = () => {
    let toXls = []
    eventList.forEach((event)=>{
      toXls = [...toXls, {'Nombre':event.name, 'Fecha':event.date, 'País':event.country, 'Región':event.region, 'Ciudad':event.city}]
    })

    const ws = utils.json_to_sheet(toXls)
    const wb = {
      Sheets:{
        'data':ws
      },
      SheetNames:['data']
    }
    const eb = write(wb,{bookType:'xlsx',type:'array'})
    const data = new Blob([eb],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UFT-8'})
    saveAs(data, 'ChannelTalks-eventos.xlsx')
  }

    const handleSureModal = async (res, event) => {
    if(event){
      setEventToDelete(event)
    }
    if(res === 'accepted'){
      await deleteGuestsDocWhereEvent(eventToDelete)
      await deleteGroupsDocWhereEvent(eventToDelete)
      await deleteEventDoc(eventToDelete)
      deleteEventMail(eventToDelete)
      setEventToDelete('')
      reloadEventList()
    }
    setSureModal(!sureModal)
    }


    const handleOrderBy = (e) => {
      setOrderBy(e.target.value)
      let list = [...eventList]
      
      
      switch (e.target.value) {
        case 'name':
          list.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
          break;
        case 'date':
          list.sort((a,b) => (a.date > b.date) ? 1 : ((b.date > a.date) ? -1 : 0))
          break; 
        default:
          break;
      }
      setEventList([...list])
    }

  return(<div  className="container mx-auto px-4">
    {loading?
    <div className="text-black py-5">
    <Spinner/>
    </div>
    :
    <>
    <h1 className="text-stone-600 font-semibold text-xl py-2">Eventos</h1>
    <div className="table-holder">
    <table className="table-auto min-w-[600px]">
      <thead>
        <tr>
          <th colSpan='100%'>
            <div className="px-5 w-full flex items-center justify-between">
              <div className="flex gap-2">
                <button className="new-element-button" onClick={()=>{handleModal()}}><MdLibraryAdd size={25}/></button>
                <form onSubmit={handleSearchForm} className='flex flex-row gap-2'>
                  <input type='text' className=" font-normal text-black" placeholder='Buscar por nombre' onChange={(e)=>{setSearch(e.target.value)}} value={search}/>
                  <select name="" className=" font-normal text-black w-fit" id="" value={orderBy || ''} onChange={handleOrderBy}>
                    <option value="name">Ordenar por Nombre</option>
                    <option value="date">Ordenar por Fecha</option>
                  </select>
                  <button className="light-button"><MdSearch size={25}/></button>

                </form>
              </div>
              <button className="light-button flex gap-1" onClick={handleDownload}>
                <MdDownload size={25}/>Descargar
              </button>
            </div>
          </th>
        </tr>
        <tr>
          <th className="w-auto sm:w-52"><h1>Acciones</h1></th>
          <th><h1>Nombre</h1></th>
          <th><h1>Fecha</h1></th>
          <th><h1>País</h1></th>
        </tr>
      </thead>
      <tbody>
        {eventList.length>0?
        <>
        {eventList.map((event, index)=>{return(
        <tr key={index}>
          <td className="flex flex-wrap gap-1 justify-center">
            <button className="action-button border-green-500 text-green-500 hover:text-white hover:bg-green-500 active:bg-green-700 duration-150" onClick={()=>{navigate('/organizer/form',{state:{title:event.name, id:event.id, form:event.form}})}}><IoDocumentText size={25}/></button>
            <button className="action-button border-blue-500 text-blue-500 hover:text-white hover:bg-blue-500 active:bg-blue-700 duration-150" onClick={()=>{navigate('/organizer/emails',{state:{title:event.name, id:event.id, emailImages:event.emailImages}})}}><IoMail size={25}/></button>
            <button className="action-button border-amber-500 text-amber-500 hover:text-white hover:bg-amber-500 active:bg-amber-700 duration-150" onClick={()=>{handleModal(event)}}><MdEdit size={25}/></button>
            <button className="action-button border-red-500 text-red-500 hover:text-white hover:bg-red-500 active:bg-red-700 duration-150" onClick={()=>{handleSureModal('', event.id); }}><MdDelete size={25}/></button>
          </td>
          <td><h1>{event.name}</h1></td>
          <td><h1>{event.date}</h1></td>
          <td><h1>{event.country}</h1></td>
        </tr>
        )})}
        </>
        :
        <>
        <tr>
          <td colSpan='100%'>No se encontraron eventos</td>
        </tr>
        </>
        }
      </tbody>
    </table>

    </div>
    <Modal isActive={showModal} handle={handleModal} title={editing===''?'Crear evento':'Editar evento'}>
      <form onSubmit={handleEventForm} className='flex flex-col gap-4'>
        <div className="input-holder w-[75%]">
          <input type='text' name="name" id="new-event-name" onChange={handleInputChange} value={newEvent.name || ''} required></input>
          <label htmlFor="new-event-name">Nombre</label>
        </div>
        <div className="input-holder w-[75%]">
          <textarea name="description" id="new-event-description" onChange={handleInputChange} value={newEvent.description || ''} required></textarea>
          <label htmlFor="new-event-description">Descripción</label>
        </div>
        <div className="input-holder w-[75%]">
          <input type='text' name="country" id="new-event-country"  onChange={handleInputChange} value={newEvent.country || ''} required></input>
          <label htmlFor="new-event-country">País</label>
        </div>
        <div className="input-holder w-[75%]">
          <input type='text' name="region" id="new-event-region"  onChange={handleInputChange} value={newEvent.region || ''} required></input>
          <label htmlFor="new-event-region">Región</label>
        </div>
        <div className="input-holder w-[75%]">
          <input type='text' name="city" id="new-event-city"  onChange={handleInputChange} value={newEvent.city || ''} required></input>
          <label htmlFor="new-event-city">Ciudad</label>
        </div>
        <div className="input-holder w-[75%]">
          <input type='text' name="address" id="new-event-address"  onChange={handleInputChange} value={newEvent.address || ''} required></input>
          <label htmlFor="new-event-address">Dirección</label>
        </div>
        <div className="input-holder w-[75%]">
          <select type='text' name="timeZone" id="new-event-time-zone"  onChange={handleInputChange} value={newEvent.timeZone || ''} required>
            <option value="" disabled hidden></option>
            <option value="+12">+12</option>
            <option value="+11">+11</option>
            <option value="+10">+10</option>
            <option value="+9">+9</option>
            <option value="+8">+8</option>
            <option value="+7">+7</option>
            <option value="+6">+6</option>
            <option value="+5">+5</option>
            <option value="+4">+4</option>
            <option value="+3">+3</option>
            <option value="+2">+2</option>
            <option value="+1">+1</option>
            <option value="0">0</option>
            <option value="-1">-1</option>
            <option value="-2">-2</option>
            <option value="-3">-3</option>
            <option value="-4">-4</option>
            <option value="-5">-5</option>
            <option value="-6">-6</option>
            <option value="-7">-7</option>
            <option value="-8">-8</option>
            <option value="-9">-9</option>
            <option value="-10">-10</option>
            <option value="-11">-11</option>

          </select>
          <label htmlFor="new-event-time-zone">Huso horario</label>
        </div>
        <div className="input-holder w-[75%]">
          <input type='date' name="date" id="new-event-date"  onChange={handleInputChange} value={newEvent.date || ''} required min={getTodaysDate()}></input>
          <label htmlFor="new-event-date">Fecha</label>
        </div>
        <div className="input-holder w-[75%]">
          <input type='time' name="startTime" id="new-event-start-time"  onChange={handleInputChange} value={newEvent.startTime || ''} required></input>
          <label htmlFor="new-event-start-time">Hora de inicio</label>
        </div>
        <div className="input-holder w-[75%]">
          <input type='time' name="endTime" id="new-event-end-time"  onChange={handleInputChange} value={newEvent.endTime || ''} required></input>
          <label htmlFor="new-event-end-time">Hora de finalización</label>
        </div>
        <div className="input-holder w-[75%]">
          <input type='number' min={1} max={100} name="visitObjective" id="new-event-visit-objective"  onChange={handleInputChange} value={newEvent.visitObjective || '70'} required/>
          <label htmlFor="new-event-visit-objective">Objetivo de visitas (%)</label>
        </div>
        <button className=" send-btn" disabled={creating}>{creating?"Guardando...":"Guardar"}</button>
      </form>
    </Modal>
    <AreYouSure isActive={sureModal} handle={handleSureModal} title='¿Eliminar evento?'/>
    </>
    }
  </div>)
}